const SOURCES = [
  { name: 'RxNorm', org: 'NIH / National Library of Medicine', desc: 'Drug name normalization' },
  { name: 'openFDA', org: 'U.S. Food & Drug Administration', desc: 'Official FDA drug-label data' },
  { name: 'Claude', org: 'Anthropic', desc: 'Large language model for explanation generation' },
];

export default function TrustSection() {
  return (
    <section className="py-16 md:py-20" style={{ backgroundColor: '#E8F4F4' }} data-testid="landing-trust">
      <div className="max-w-5xl mx-auto px-4 sm:px-6">
        <h2 className="text-3xl sm:text-4xl font-extrabold text-center mb-12" style={{ color: '#5B2D1F' }}>
          Built on trusted data
        </h2>

        <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 mb-12">
          {SOURCES.map((s) => (
            <div
              key={s.name}
              className="rounded-2xl p-6 text-center"
              style={{ backgroundColor: '#FFFFFF' }}
              data-testid={`landing-source-${s.name.toLowerCase()}`}
            >
              <p className="text-xl font-extrabold" style={{ color: '#D77A52' }}>{s.name}</p>
              <p className="text-xs font-semibold mt-1" style={{ color: '#8B7A6B' }}>{s.org}</p>
              <p className="text-sm mt-2" style={{ color: '#5B2D1F' }}>{s.desc}</p>
            </div>
          ))}
        </div>

        <div className="rounded-2xl p-6 md:p-8" style={{ backgroundColor: '#FFFFFF' }}>
          <h3 className="text-lg font-extrabold mb-2" style={{ color: '#5B2D1F' }}>Your data, your control</h3>
          <p className="text-sm leading-relaxed" style={{ color: '#6B4A3A' }}>
            Encrypted at rest. Email/password auth. We never sell or share your data.
            Export or delete your account at any time.
          </p>
        </div>
      </div>
    </section>
  );
}
